
const API_HOST = 'https://aditya-pal-portfolio-bucket.s3.us-east-1.amazonaws.com'

export {
    API_HOST
}